import React from "react";

export const DashboardCard = ({ title, action, children, className = "" }) => {
  return (
    <div
      className={`bg-white rounded-2xl border border-slate-200/80 shadow-[0_4px_20px_rgba(0,0,0,0.03)] hover:shadow-[0_8px_25px_rgba(0,0,0,0.06)] transition-all duration-300 p-4 sm:p-5 flex flex-col justify-between overflow-hidden ${className}`}
    >
      {title && (
        <div className="flex items-center justify-between gap-2 mb-3 pb-2 border-b border-slate-100">
          <h3 className="text-xs sm:text-sm font-bold text-slate-800 tracking-tight flex items-center gap-2">
            {title}
          </h3>
          {action && <div>{action}</div>}
        </div>
      )}
      <div className="w-full flex-1 flex flex-col justify-between">{children}</div>
    </div>
  );
};

export const ModernStatWidget = ({
  title,
  value,
  subValue,
  icon,
  percentage,
  isNegative,
  bgColor = "bg-[#048178]/10",
  iconColor = "text-[#048178]",
  badgeLabel = "this month",
}) => {
  return (
    <div className="bg-white rounded-2xl border border-slate-200/80 p-4 sm:p-5 shadow-[0_4px_20px_rgba(0,0,0,0.03)] hover:shadow-[0_8px_25px_rgba(0,0,0,0.06)] transition-all duration-300 flex items-center justify-between gap-4 w-full">
      <div className="flex flex-col gap-1 min-w-0">
        <span className="text-xs font-semibold text-slate-500 uppercase tracking-wider truncate">
          {title}
        </span>
        <div className="flex items-baseline gap-2">
          <span className="text-xl sm:text-2xl font-extrabold text-slate-900 tracking-tight">
            {value !== undefined && value !== null ? value : 0}
          </span>
          {subValue && (
            <span className="text-xs font-medium text-slate-400">
              {subValue}
            </span>
          )}
        </div>
        {percentage !== undefined && percentage !== null && (
          <div className="flex items-center gap-1.5 mt-1">
            <span
              className={`inline-flex items-center gap-0.5 px-2 py-0.5 rounded-full text-[11px] font-bold ${
                isNegative
                  ? "bg-rose-50 text-rose-600 border border-rose-100"
                  : "bg-emerald-50 text-emerald-600 border border-emerald-100"
              }`}
            >
              <svg
                className={`w-3 h-3 ${isNegative ? "rotate-180" : ""}`}
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth={2.5}
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M5 15l7-7 7 7"
                />
              </svg>
              {Math.abs(percentage)}%
            </span>
            <span className="text-[11px] font-medium text-slate-400">
              {badgeLabel}
            </span>
          </div>
        )}
      </div>

      {icon && (
        <div
          className={`w-11 h-11 sm:w-12 sm:h-12 rounded-xl flex items-center justify-center shrink-0 ${bgColor} ${iconColor}`}
        >
          {icon}
        </div>
      )}
    </div>
  );
};

export default DashboardCard;
